<template>
  <v-app class="vapp">
    <v-container class="mx-auto vcontainer">
      <v-stepper alt-labels class="my-3" v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            お客様情報入力
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">確認</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3" step="3">
            送信完了
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <v-card class="mx-auto" max-width="100%">
        <v-container fluid>
          <v-card-title><h2>お客様情報入力フォーム</h2> </v-card-title>
          <p class="mx-4 mb-6" v-if="step == 1">
            下記フォームに必要事項をご記入の上、確認ボタンを押してください。<br />
            弊社からご連絡させていただきます。
          </p>
          <v-alert v-if="step == 2" type="warning">
            お申し込みはまだ完了していません
          </v-alert>
          <p class="mx-4" v-if="step == 2">
            入力内容を確認して、送信してください。
          </p>
          <v-card-text>
            <template v-if="step == 1">
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-toolbar-title>お客様情報</v-toolbar-title>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required]"
                      v-model="last_name"
                      label="姓*"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required]"
                      v-model="first_name"
                      label="名*"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required, AllKana_rule]"
                      v-model="last_nameKana"
                      label="セイ*"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required, AllKana_rule]"
                      v-model="first_nameKana"
                      label="メイ*"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-menu
                      ref="birthDayMenu"
                      v-model="birthDayMenu"
                      :close-on-content-click="false"
                      :return-value.sync="birthDay"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="birthDay"
                          label="生年月日"
                          required
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="birthDayPicker"
                        v-model="birthDay"
                        scrollable
                        locale="ja"
                        :day-format="(date) => new Date(date).getDate()"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu = birthDayMenu"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.birthDayMenu.save(birthDay)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      ref="email"
                      v-model="email"
                      label="メールアドレス*"
                      :rules="[emailRules2]"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="mobile"
                      label="電話番号*"
                      :rules="[required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-toolbar-title>入居先情報</v-toolbar-title>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[postalCodeRule]"
                      label="郵便番号*"
                      v-model="zip"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6"> </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required]"
                      label="都道府県*"
                      v-model="state"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required]"
                      label="市区町村*"
                      v-model="city"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      :rules="[required]"
                      label="町名"
                      v-model="street"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6"> </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      ref="chome"
                      required
                      :rules="[chomeRule, number_rule2]"
                      label="丁目"
                      v-model="chome"
                    >
                    </v-text-field>
                    <v-checkbox
                      v-model="not_chome"
                      @change="valid_chome"
                      label="丁目が存在しない住所"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      ref="banti"
                      required
                      :rules="[bantiRule, number_rule2]"
                      label="番地"
                      v-model="banti"
                    >
                    </v-text-field>
                    <v-checkbox
                      v-model="not_banti"
                      @change="valid_banti"
                      label="番地が存在しない住所"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      ref="gou"
                      required
                      :rules="[gouRule, number_rule2]"
                      label="号"
                      v-model="gou"
                    >
                    </v-text-field>
                    <v-checkbox
                      v-model="not_gou"
                      @change="valid_gou"
                      label="号が存在しない住所"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :rules="[All_rule]"
                      @input="BuildingReplace()"
                      v-model="Building"
                      label="建物名"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      ref="building_kana"
                      v-model="Building_kana"
                      label="建物名カナ"
                      required
                      @input="BuildingReplace_kanaReplace"
                      :rules="[Building_kanaRule]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="roomNumber"
                      :rules="[herf_rule]"
                      label="部屋番号"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-menu
                      ref="MoveInDateMenu"
                      v-model="MoveInDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="MoveInDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="MoveInDate"
                          label="入居日*"
                          :rules="[required]"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="MoveInDate"
                        scrollable
                        :allowed-dates="allowedDates"
                        locale="ja"
                        :day-format="(date) => new Date(date).getDate()"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="MoveInDateMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.MoveInDateMenu.save(MoveInDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="MoveInDateRemarks"
                      label="入居日についてのその他ご要望"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-toolbar-title>その他</v-toolbar-title>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-menu
                      ref="DesiredDateOfContactMenu"
                      v-model="DesiredDateOfContactMenu"
                      :close-on-content-click="false"
                      :return-value.sync="DesiredDateOfContact"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="DesiredDateOfContact"
                          label="連絡希望日"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="DesiredDateOfContact"
                        scrollable
                        locale="ja"
                        :day-format="(date) => new Date(date).getDate()"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="DesiredDateOfContactMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.DesiredDateOfContactMenu.save(
                              DesiredDateOfContact
                            )
                          "
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                    <p>お受付確認のお電話をさせていただきます</p>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      clearable
                      v-model="desiredContactTime"
                      :items="[
                        { text: '10時', value: '10:00' },
                        { text: '11時', value: '11:00' },
                        { text: '12時', value: '12:00' },
                        { text: '13時', value: '13:00' },
                        { text: '14時', value: '14:00' },
                        { text: '15時', value: '15:00' },
                        { text: '16時', value: '16:00' },
                        { text: '17時', value: '17:00' },
                        { text: '18時', value: '18:00' },
                        { text: '19時', value: '19:00' },
                        { text: '20時', value: '20:00' },
                      ]"
                      label="連絡希望時間帯"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="desiredContactType"
                      clearable
                      :items="['以降', '丁度']"
                      label="以降、丁度"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="DesiredDateOfContactRemarks"
                      label="連絡希望日についての備考"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <h5 style="color: red" class="">
                      ※物件情報について、必ず選択をお願いいたします。
                    </h5>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <p>水道の案内を</p>
                    <v-radio-group v-model="WantWater" row>
                      <v-radio label="希望する" value="希望する"></v-radio>
                      <v-radio label="希望しない" value="希望しない"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <p>電気の案内を</p>
                    <v-radio-group v-model="electricity" row>
                      <v-radio label="希望する" value="希望する"></v-radio>
                      <v-radio label="希望しない" value="希望しない"></v-radio>
                    </v-radio-group>
                    <v-select
                      v-if="electricity == '希望する'"
                      v-model="electricalOption"
                      clearable
                      :rules="[required]"
                      required
                      :items="[
                        'オール電化',
                        '電気給湯器あり',
                        'オール電化ではない',
                        'わからない',
                      ]"
                      label="電気"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <p>ガスの案内を</p>
                    <v-radio-group v-model="WantGas" row>
                      <v-radio label="希望する" value="希望する"></v-radio>
                      <v-radio label="希望しない" value="希望しない"></v-radio>
                    </v-radio-group>
                    <v-select
                      v-if="WantGas == '希望する'"
                      v-model="gasOption"
                      clearable
                      :rules="[required]"
                      required
                      :items="[
                        '都市ガス',
                        'プロパンガス',
                        'オール電化',
                        'わからない',
                      ]"
                      label="ガス"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="this.gasOption.indexOf('プロパンガス') !== -1"
                  >
                    <v-text-field
                      v-model="propaneGasCompanyName"
                      label="プロパンガス会社名"
                      :rules="[propaneGasRule]"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="this.gasOption.indexOf('プロパンガス') !== -1"
                  >
                    <v-text-field
                      v-model="propaneGasContact"
                      label="プロパンガス連絡先"
                      :rules="[propaneGasRule]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <p>インターネットの案内を</p>
                    <v-radio-group v-model="WantInternet" row>
                      <v-radio label="希望する" value="希望する"></v-radio>
                      <v-radio label="希望しない" value="希望しない"></v-radio>
                    </v-radio-group>
                    <p v-if="WantInternet == '希望する'">
                      インターネット(インターネット無料物件でしたらチェックお願いします)
                    </p>
                    <v-checkbox
                      v-if="WantInternet == '希望する'"
                      v-model="internetOption"
                      label="ネット無料物件"
                      value="ネット無料物件"
                    ></v-checkbox>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="remarks"
                      label="その他ご要望"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </template>
            <template v-if="step == 2">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-toolbar-title>お客様情報</v-toolbar-title>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">姓*</p>
                  <p class="text-h6 my-0">
                    {{ last_name ? last_name : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">名*</p>
                  <p class="text-h6 my-0">
                    {{ first_name ? first_name : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">セイ*</p>
                  <p class="text-h6 my-0">
                    {{ last_nameKana ? last_nameKana : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">メイ*</p>
                  <p class="text-h6 my-0">
                    {{ first_nameKana ? first_nameKana : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">生年月日</p>
                  <p class="text-h6 my-0">
                    {{ birthDay ? birthDay : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">メールアドレス*</p>
                  <p class="text-h6 my-0">{{ email ? email : "未入力" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">電話番号*</p>
                  <p class="text-h6 my-0">{{ mobile ? mobile : "未入力" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-toolbar-title>入居先情報</v-toolbar-title>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">郵便番号*</p>
                  <p class="text-h6 my-0">{{ zip ? zip : "未入力" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6"> </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">都道府県*</p>
                  <p class="text-h6 my-0">{{ state ? state : "未入力" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">市区町村*</p>
                  <p class="text-h6 my-0">{{ city ? city : "未入力" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">町名</p>
                  <p class="text-h6 my-0">{{ street ? street : "未入力" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6"> </v-col>
                <v-col cols="12" sm="4">
                  <p class="text-subtitle-2 my-0">丁目</p>
                  <p class="text-h6 my-0">{{ chome ? chome : "なし" }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                  <p class="text-subtitle-2 my-0">番地</p>
                  <p class="text-h6 my-0">{{ banti ? banti : "なし" }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                  <p class="text-subtitle-2 my-0">号</p>
                  <p class="text-h6 my-0">{{ gou ? gou : "なし" }}</p>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">建物名</p>
                  <p class="text-h6 my-0">{{ Building ? Building : "なし" }}</p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">建物名カナ</p>
                  <p class="text-h6 my-0">
                    {{ Building_kana ? Building_kana : "なし" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">部屋番号</p>
                  <p class="text-h6 my-0">
                    {{ roomNumber ? roomNumber : "なし" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">
                    入居日*
                  </p>
                  <p class="text-h6 my-0">
                    {{ MoveInDate ? MoveInDate : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">
                    入居日についてのその他ご要望
                  </p>
                  <p class="text-h6 my-0">
                    {{ MoveInDateRemarks ? MoveInDateRemarks : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-toolbar-title>その他</v-toolbar-title>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">連絡希望日</p>
                  <p class="text-h6 my-0">
                    {{ DesiredDateOfContact ? DesiredDateOfContact : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">連絡希望時間帯</p>
                  <p class="text-h6 my-0">
                    {{ desiredContactTime ? desiredContactTime : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-subtitle-2 my-0">以降、丁度</p>
                  <p class="text-h6 my-0">
                    {{ desiredContactType ? desiredContactType : "未入力" }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">連絡希望日についての備考</p>
                  <p class="text-h6 my-0">
                    {{
                      DesiredDateOfContactRemarks
                        ? DesiredDateOfContactRemarks
                        : "未入力"
                    }}
                  </p>
                  <v-divider class="my-1"></v-divider>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">水道の案内をの案内を</p>
                  <p class="text-h6 my-0">
                    {{ WantWater }}
                  </p>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">電気の案内を</p>
                  <p class="text-h6 my-0">
                    {{ electricity }}
                  </p>
                </v-col>
                <v-col v-if="electricity == '希望する'" cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">電気</p>
                  <p class="text-h6 my-0">
                    {{ electricalOption.length != 0 ? electricalOption : "" }}
                  </p>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">ガスの案内を</p>
                  <p class="text-h6 my-0">
                    {{ WantGas }}
                  </p>
                </v-col>
                <v-col v-if="WantGas == '希望する'" cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">ガス</p>
                  <p class="text-h6 my-0">
                    {{ gasOption.length != 0 ? gasOption : "" }}
                  </p>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  v-if="this.gasOption.indexOf('プロパンガス') !== -1"
                >
                  <p class="text-subtitle-2 my-0">プロパンガス会社名</p>
                  <p class="text-h6 my-0">{{ propaneGasCompanyName }}</p>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="this.gasOption.indexOf('プロパンガス') !== -1"
                >
                  <p class="text-subtitle-2 my-0">プロパンガス連絡先</p>
                  <p class="text-h6 my-0">{{ propaneGasContact }}</p>
                </v-col>

                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">インターネットの案内を</p>
                  <p class="text-h6 my-0">
                    {{ WantInternet }}
                  </p>
                </v-col>

                <v-col v-if="WantInternet == '希望する'" cols="12" sm="12">
                  <v-checkbox
                    disabled
                    v-if="WantInternet == '希望する'"
                    v-model="internetOption"
                    label="ネット無料物件"
                    value="ネット無料物件"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12">
                  <p class="text-subtitle-2 my-0">その他ご要望</p>
                  <p class="text-h6 my-0">{{ remarks }}</p>
                </v-col>
              </v-row>
            </template>
            <template v-if="step == 3">
              <h3>お申込みを受け付けました</h3>
              <p>
                <br />
                この度はお申込みをいただき、誠にありがとうございました。<br />
                担当者よりご連絡をさせていただきます。<br /><br />
                ※弊社からのお電話にて、お受付が最終確定となります。<br /><br />
                お急ぎの方は、下記の電話番号よりご連絡ください。<br /><br />
                株式会社ClassLab. 0120-409-732<br />
                平日10:00～20:00　土日祝10:00～18:00<br /></p
            ></template>
          </v-card-text>
          <v-card-actions>
            <template v-if="step == 1">
              <v-spacer></v-spacer>
              <v-btn depressed @click="Confirmation" color="primary">
                確認
              </v-btn>
            </template>
            <template v-if="step == 2">
              <v-btn depressed @click="prev" color="primary"> 戻る </v-btn>
              <v-spacer></v-spacer>
              <v-btn depressed @click="post" color="primary"> 送信 </v-btn>
            </template>
            <template v-if="step == 3">
              <v-spacer></v-spacer>
            </template>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="3000">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          閉じる
        </v-btn>
      </template>
    </v-snackbar>
    <iframe
      name="sendPhoto"
      style="width: 0px; height: 0px; border: 0px"
    ></iframe>
  </v-app>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  created() {
    let vm = this;
    axios
      .get("https://holidays-jp.github.io/api/v1/date.json")
      .then((response) => {
        vm.holiday = response.data;
      });
  },
  methods: {
    toTopPage() {
      window.location =
        "http://resident-form.classlab.co.jp/form" + window.location.search;
    },
    customFormatter(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    //00N5h000004MxAD 丁目
    //00N5h000004MxAN 番地
    //00N5h000004MxAS 号

    post() {
      var pattern = /^[0-9０-９]?$/;
      if (pattern.test(this.street.slice(-1))) {
        this.street += "-";
      }
      let data = {
        debug: 1,
        debugEmail: "t.hirai@fireflyinc.io",
        oid: "00D5h000000IRO9", //本番
        //oid: '00D0l0000001stV',
        retURL: "https://classlab.co.jp",
        "00N5h0000017Bya": "0015h00000CcDE8AAN",
        "00N5h000004NcQM": 1, //ForLp
        "00N5h0000017Byu": 1, //IsWebTo
        "00N5h0000017FGx": this.staffLastName, //担当者姓
        "00N5h0000017FXM": this.staffFirststName, //担当者名
        last_name: this.last_name, //入居者姓
        first_name: this.first_name, //入居者名
        "00N5h0000017FI9": this.last_nameKana, //
        "00N5h0000017FI4": this.first_nameKana, //
        "00N5h0000017FJ7": moment(this.birthDay).format("YYYY/MM/DD"), //誕生日
        email: this.email, //
        mobile: this.mobile, //
        "00N5h0000017FXH": this.MobileCareer, //携帯キャリア
        MobileCareer: null,
        "00N5h0000017TpP": this.Type, //物件タイプ
        zip: this.zip, //郵便番号
        state: this.state, //都道府県
        city: this.city, //市区群
        street: this.street, //町名番地
        "00N5h0000017FIJ": this.Building, //建物名
        "00N5h000001APZB": this.Building_kana, //建物名カナ
        "00N5h0000017FJC": this.roomNumber, // 部屋番号
        "00N5h0000017FHz": moment(this.MoveInDate).format("YYYY/MM/DD"), //入居予定日
        "00N5h0000017Tp5": this.propaneGasCompanyName, //プロパンガス会社名
        "00N5h0000017TpA": this.propaneGasContact, //プロパンガス連絡先
        "00N5h0000017sC4": moment(this.DesiredDateOfContact).format(
          "YYYY/MM/DD"
        ), //連絡希望日
        "00N5h0000017TpU": this.desiredContactType, //連絡希望時間種別
        "00N5h0000017FIT": this.internetOption.join(";"), //インターネットオプション
        "00N5h0000017FIY": this.electricalOption, //電気オプション
        "00N5h0000017FId": this.waterOption, //水道オプション
        "00N5h0000017FIi": this.gasOption, //ガスオプション
        "00N5h0000017FIO": this.remarks, //備考
        "00N5h0000018WKx": this.MoveInDateRemarks, //入居予定日備考
        "00N5h0000018WL7": this.DesiredDateOfContactRemarks, //連絡希望日備考
        "00N5h0000018WL2": this.NotificationEmail, //完了メール通知先
        "00N5h000004MPOI": this.SendSMS,
        "00N5h000004MxAD": this.chome,
        "00N5h000004MxAN": this.banti,
        "00N5h000004MxAS": this.gou,
        "00N5h000004NcQR": this.WantGas != "希望する" ? 0 : 1, //ガスの案内
        "00N5h000004NcQW": this.WantInternet != "希望する" ? 0 : 1, //インターネットの案内を希望する
        "00N5h000004NcQb": this.electricity != "希望する" ? 0 : 1, //電気の案内を希望する
        "00N5h000004NcQg": this.WantWater != "希望する" ? 0 : 1, //水道の案内を希望する
      };
      if (this.desiredContactTime != null) {
        data["00N5h0000017FIE"] = this.desiredContactTime + ":00.000Z"; //連絡希望時間
      }
      var form = document.createElement("form");
      //form.action = 'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';
      form.action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";

      form.method = "post";
      Object.keys(data).forEach(function(k) {
        let q = document.createElement("input");
        q.value = data[k];
        q.name = k;
        form.appendChild(q);
      });

      form.target = "sendPhoto";

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
      this.step = 3;
      this.totop();
    },
    allowedDates(val) {
      console.log(val);
      // 今日～100日後までを選べるようにする
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let maxAllowedDay = new Date();
      maxAllowedDay.setDate(today.getDate() + 2);
      maxAllowedDay = new Date(
        maxAllowedDay.getFullYear(),
        maxAllowedDay.getMonth(),
        maxAllowedDay.getDate()
      );

      if (this.holiday[val]) {
        return false;
      }
      if (new Date(val).getDay() == 0 || new Date(val).getDay() == 6) {
        return false;
      }
      return new Date(val) >= maxAllowedDay;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    prev() {
      this.step = 1;
    },
    BuildingReplace() {
      this.Building = this.hankana2Zenkana(this.zenkaku2Hankaku(this.Building));
      this.valid_building_kana();
    },
    BuildingReplace_kanaReplace() {
      this.Building_kana = this.hankana2Zenkana(
        this.zenkaku2Hankaku(this.Building_kana)
      );
    },
    zenkaku2Hankaku(str) {
      return str.replace(/[A-Za-z0-9]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
      });
    },
    phoneInput() {
      this.mobile = this.str2japan_phone_number(this.mobile);
    },
    hankana2Zenkana(str) {
      var kanaMap = {
        ｶﾞ: "ガ",
        ｷﾞ: "ギ",
        ｸﾞ: "グ",
        ｹﾞ: "ゲ",
        ｺﾞ: "ゴ",
        ｻﾞ: "ザ",
        ｼﾞ: "ジ",
        ｽﾞ: "ズ",
        ｾﾞ: "ゼ",
        ｿﾞ: "ゾ",
        ﾀﾞ: "ダ",
        ﾁﾞ: "ヂ",
        ﾂﾞ: "ヅ",
        ﾃﾞ: "デ",
        ﾄﾞ: "ド",
        ﾊﾞ: "バ",
        ﾋﾞ: "ビ",
        ﾌﾞ: "ブ",
        ﾍﾞ: "ベ",
        ﾎﾞ: "ボ",
        ﾊﾟ: "パ",
        ﾋﾟ: "ピ",
        ﾌﾟ: "プ",
        ﾍﾟ: "ペ",
        ﾎﾟ: "ポ",
        ｳﾞ: "ヴ",
        ﾜﾞ: "ヷ",
        ｦﾞ: "ヺ",
        ｱ: "ア",
        ｲ: "イ",
        ｳ: "ウ",
        ｴ: "エ",
        ｵ: "オ",
        ｶ: "カ",
        ｷ: "キ",
        ｸ: "ク",
        ｹ: "ケ",
        ｺ: "コ",
        ｻ: "サ",
        ｼ: "シ",
        ｽ: "ス",
        ｾ: "セ",
        ｿ: "ソ",
        ﾀ: "タ",
        ﾁ: "チ",
        ﾂ: "ツ",
        ﾃ: "テ",
        ﾄ: "ト",
        ﾅ: "ナ",
        ﾆ: "ニ",
        ﾇ: "ヌ",
        ﾈ: "ネ",
        ﾉ: "ノ",
        ﾊ: "ハ",
        ﾋ: "ヒ",
        ﾌ: "フ",
        ﾍ: "ヘ",
        ﾎ: "ホ",
        ﾏ: "マ",
        ﾐ: "ミ",
        ﾑ: "ム",
        ﾒ: "メ",
        ﾓ: "モ",
        ﾔ: "ヤ",
        ﾕ: "ユ",
        ﾖ: "ヨ",
        ﾗ: "ラ",
        ﾘ: "リ",
        ﾙ: "ル",
        ﾚ: "レ",
        ﾛ: "ロ",
        ﾜ: "ワ",
        ｦ: "ヲ",
        ﾝ: "ン",
        ｧ: "ァ",
        ｨ: "ィ",
        ｩ: "ゥ",
        ｪ: "ェ",
        ｫ: "ォ",
        ｯ: "ッ",
        ｬ: "ャ",
        ｭ: "ュ",
        ｮ: "ョ",
        "｡": "。",
        "､": "、",
        ｰ: "ー",
        "｢": "「",
        "｣": "」",
        "･": "・",
      };

      var reg = new RegExp("(" + Object.keys(kanaMap).join("|") + ")", "g");
      return str
        .replace(reg, function(match) {
          return kanaMap[match];
        })
        .replace(/ﾞ/g, "゛")
        .replace(/ﾟ/g, "゜");
    },
    valid_chome() {
      this.$refs.chome.validate();
    },
    valid_banti() {
      this.$refs.banti.validate();
    },
    valid_gou() {
      this.$refs.gou.validate();
    },
    valid_building_kana() {
      this.$refs.building_kana.validate();
    },
    valid_email() {
      this.$refs.email.validate();
    },
    Confirmation() {
      if (this.$refs.form.validate()) {
        this.success = true;
        this.step = 2;
      } else {
        this.snackbar = true;
        this.snackbarText =
          "入力項目にエラーあります、各項目のメッセージを確認してください。";
      }
      this.totop();
    },
    totop() {
      const duration = 400; // 移動速度（1秒で終了）
      const interval = 25; // 0.025秒ごとに移動
      const step = -window.scrollY / Math.ceil(duration / interval); // 1回に移動する距離
      const timer = setInterval(() => {
        window.scrollBy(0, step); // スクロール位置を移動

        if (window.scrollY <= 0) {
          clearInterval(timer);
        }
      }, interval);
    },
  },
  data() {
    return {
      step: 1,
      default: "2018-10-04",
      DatePickerFormat: "yyyy-MM-dd",
      AccountName: null,
      Introduction: "0015h00000Ab729AAB", //紹介不動産
      staffLastName: null, // 担当者姓
      staffFirststName: null, // 担当者名
      NotificationEmail: "", //完了メール通知先
      //入居者
      last_name: null, //姓
      first_name: null, //名
      last_nameKana: null, //セイ
      first_nameKana: null, //メイ
      birthDay: null, //誕生日
      email: null, // メールアドレス
      mobile: null, //携帯番号
      MobileCareer: "不明", //携帯キャリア
      Type: "", //物件タイプ
      zip: null, //郵便番号
      state: null, //都道府県
      city: null, //市区群
      street: null, //町名番地
      street2: null,
      Building: "", //建物名
      Building_kana: "",
      roomNumber: null, // 部屋番号
      MoveInDate: null, //入居予定日
      MoveInDateRemarks: null, //入居予定日備考
      propaneGasCompanyName: null, //プロパンガス会社名
      propaneGasContact: null, //プロパンガス連絡先
      DesiredDateOfContact: null, //連絡希望日
      desiredContactTime: null, //連絡希望時間
      desiredContactType: null, //連絡希望時間種別
      DesiredDateOfContactRemarks: null, //連絡希望日備考
      internetOption: [], //インターネットオプション
      electricalOption: [], //電気オプション
      waterOption: [], //水道オプション
      gasOption: [], //ガスオプション
      remarks: null, //備考};
      birthDayMenu: false,
      DesiredDateOfContactMenu: false,
      MoveInDateMenu: false,
      desiredContactTimeMenu: false,
      not_email: false,
      chome: "",
      not_chome: false,
      banti: "",
      not_banti: false,
      not_gou: false,
      gou: "",
      WantGas: "希望する",
      electricity: "希望する",
      WantWater: "希望する",
      WantInternet: "希望する",
      //20210501
      SendSMS: false,
      holiday: {},
      //バリデーションルール
      All_rule: (v) => {
        const pattern = /^[ａ-ｚＡ-Ｚ０-９ぁ-んァ-ヶ一-龠\u3005-\u3006\uF900-\uFAFFー　]*$/;
        if (v != null && v !== "" && !pattern.test(v)) {
          return false || "全角で入力してください";
        }
        return true;
      },
      AllKana_rule: (v) => {
        const pattern = /^[ァ-ンヴー　]*$/;
        if (v != null && v !== "" && !pattern.test(v)) {
          return false || "全角カナで入力してください";
        }
        return true;
      },
      herf_rule: (v) => {
        const pattern = /^[0-9a-zA-Z]*$/;
        if (v != null && v !== "" && !pattern.test(v)) {
          return false || "半角英数で入力してください";
        }
        return true;
      },
      number_rule: (v) => {
        const pattern = /^[0-9]+$/;
        if (v != null && v !== "" && !pattern.test(v)) {
          return false || "数値で入力してください";
        }
        return true;
      },
      number_rule2: (v) => {
        const pattern = /^[0-9-]+$/;
        if (v != null && v !== "" && !pattern.test(v)) {
          return false || "数値で入力してください";
        }
        return true;
      },
      chomeRule: (v) => {
        if (this.not_chome) {
          return true;
        }
        if ((v == null || v === "") && !this.not_chome) {
          return false || "丁目は必須です";
        }
        return true;
      },
      bantiRule: (v) => {
        if (this.not_banti) {
          return true;
        }
        if ((v == null || v === "") && !this.not_chome) {
          return false || "番地は必須です";
        }
        return true;
      },
      gouRule: (v) => {
        if (this.not_gou) {
          return true;
        }
        if ((v == null || v === "") && !this.not_gou) {
          return false || "号は必須です";
        }
        return true;
      },
      required: (value) => !!value || "必須項目です",
      emailRules: (v) => {
        const pattern = /.+@.+\..+/;
        return pattern.test(v) || "メールアドレスの形式を確認してください";
      },

      emailRules2: (v) => {
        if ((v == null || v === "") && !this.not_email) {
          return false || "メールアドレスは必須です、";
        }

        const pattern = /.+@.+\..+/;
        return pattern.test(v) || "メールアドレスの形式を確認してください";
      },
      postalCodeRule: (v) =>
        /^[0-9]{3}-[0-9]{4}$/.test(v) ||
        "郵便番号の形式は000-0000で入力ください",
      phoneNumberRule: (v) => {
        if (v == null || v === "") {
          return true;
        }

        const pattern = /^0\d{1,2}-\d{1,4}-\d{4}$/;
        return (
          pattern.test(v) || "電話番号をハイフン付きで正しく入力してください"
        );
      },
      propaneGasRule: (v) => {
        if (this.gasOption.indexOf("プロパンガス") !== -1) {
          if (v != null || v !== "") {
            return !!v || "必須項目です";
          }
        }
      },
      Building_kanaRule: (v) => {
        const pattern = /^[ァ-ンヴー　]*$/;

        if (v != null && v !== "" && !pattern.test(v)) {
          return false || "全角カナで入力してください";
        }
        if (this.Building !== null && this.Building !== "") {
          if (v != null || v !== "") {
            return !!v || "必須項目です";
          }
        }
        return true;
      },
      desiredContactTimeRule: (v) => {
        if (v != null && v !== "") {
          let val = v.replace(/:/g, "");
          if (val > 2000 || val < 1000) {
            return "10時から20時迄でご選択ください";
          }
        }
        return true;
      },

      snackbar: false,
      snackbarText: "",
    };
  },
  watch: {
    zip: function(zip) {
      if (zip.match(/^\d{3}-?\d{4}$/)) {
        let _this = this;
        if (this.zip.length != 8) {
          this.zip = zip.slice(0, 3) + "-" + zip.slice(3, zip.length);
        }

        new YubinBango.Core(zip.replace("-", ""), function(addr) {
          _this.state = addr.region; // 都道府県ID
          _this.city = addr.locality; // 市区町村
          _this.street = addr.street; // 町域
        });
      }
    },
    birthDayMenu(val) {
      val &&
        setTimeout(() => (this.$refs.birthDayPicker.activePicker = "YEAR"));
    },
  },
};
</script>
<style lang="css">
.vapp {
  background-color: transparent !important;
}

.vcontainer {
  max-width: 1024px !important;
}
</style>
